import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import AddCustomerToLoanModalSF from './AddCustomerToLoanModalSF'
import ProjectsNavUI from '../../../components/superUser/loan/ProjectsNavUI.js';
import './LoanDetail.css'

const ProjectDetailUI = ({ context, loan, onRefreshClick,
  filteredCustomerList, selectedCustomer,
  onDownloadPrjFileClick,
  // modals
  addCustomerMode, onAddCustomerClick, onAddCustomerCancel,
  onCreateProjectClick, onProjectUpdateClick
}) =>
  <div className='su_loan'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <IconButtonUI icon='icon-plus' onClick={onCreateProjectClick} />
          <span className='g_m_left_100 g_large'><b>Projects</b></span>
        </span>
      }
    />
    {
      loan &&
      <ProjectsNavUI loan={loan} page='projects' />
    }
    <div className='g_flex_h g_flex_top g_m_top_50'>
      <LeftUI context={context} loan={loan}
        filteredCustomerList={filteredCustomerList} selectedCustomer={selectedCustomer}
        onRefreshClick={onRefreshClick}
        onDownloadPrjFileClick={onDownloadPrjFileClick}
        addCustomerMode={addCustomerMode} onAddCustomerClick={onAddCustomerClick} onAddCustomerCancel={onAddCustomerCancel}
        onProjectUpdateClick={onProjectUpdateClick}
      />
    </div>
  </div>

const LeftUI = ({ context, loan,
  filteredCustomerList, selectedCustomer,
  onRefreshClick, onDownloadPrjFileClick,
  addCustomerMode, onAddCustomerClick, onAddCustomerCancel,
  onProjectUpdateClick
}) =>
  <div className='g_flex_v'>
    <div className='g_m_top_50'>
    </div>
    {
      (loan.termSheet.project || loan.termSheet.referenceProjectList) &&
      <ProjectUI context={context} loan={loan} onDownloadPrjFileClick={onDownloadPrjFileClick}
        onProjectUpdateClick={onProjectUpdateClick} />
    }
    <CustomerRowUI context={context} loan={loan}
      customerList={loan.customerList} selectedCustomer={selectedCustomer}
      onAddCustomerClick={onAddCustomerClick} />

    <AddCustomerToLoanModalSF context={context} loan={loan} filteredCustomerList={filteredCustomerList}
      updateMode={addCustomerMode} onCancelClick={onAddCustomerCancel} onRefreshClick={onRefreshClick} />

  </div>


const ProjectUI = ({ context, loan, selectedCustomer, onDownloadPrjFileClick, onProjectUpdateClick }) =>
  <div>
    <CardUI title='Project to be financed / Counter party' className='g_m_top_100'>
      {loan.termSheet.projectList &&
        <LRTableRowUI className='g_flex_top'
          left={
            <div>
              {
                <table>
                  <thead>
                    <tr className='head g_sticky'>
                      <th>Project</th>
                      <th className='g_p_left_100'>Customer</th>
                      <th className='g_p_left_100'>Cost</th>
                      <th className='g_p_left_100'>Margin</th>
                      <th className='g_p_left_100'>Attachment</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      loan.termSheet.projectList.map((project, i) =>
                        <tr className='acc' key={i}>
                          <td>{project.projectName}</td>
                          <td className='g_p_left_100'>{project.customerName}</td>
                          <td className='g_p_left_100 g_text_right amt'>{project.projectCostF2}</td>
                          <td className='g_p_left_100 g_text_right amt'>{project.expectedMarginPercent}</td>
                          <td className='g_p_left_100'> {loan.termSheet.project.fileList['attachments'] &&
                            <Link onClick={onDownloadPrjFileClick} to='#' data-id={loan.termSheet.project.projectId}>
                              Download attachment
                            </Link>
                          }</td>
                          <td>
                            <span className='icon icon-pencil g_link_2 g_m_left_100'
                              onClick={onProjectUpdateClick} data-project-id={project.projectId}
                            />
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
              }
            </div>
          }
          right={<span />}
        />
      }
    </CardUI>
    {
      loan.termSheet.referenceProjectList &&
      <CardUI title='Reference projects' className='g_m_top_100'>
        <div className='g_flex_h g_flex_left'>
          <div>
            {
              loan.termSheet.referenceProjectList.map((project, i) =>
                <div key={i}>{project.projectName}</div>
              )
            }
          </div><div className='g_m_left_100'>
            {
              loan.termSheet.referenceProjectList.map((project, i) =>
                <div key={i}>PO: {project.orderTotalF2}</div>
              )
            }
          </div><div className='g_m_left_100'>
            {
              loan.termSheet.referenceProjectList.map((project, i) =>
                <div key={i}>received: {project.paymentReceivedF2}</div>
              )
            }
          </div><div className='g_m_left_100'>
            {
              loan.termSheet.referenceProjectList.map((project, i) =>
                <div key={i}>LD: {project.ldPaidF2}</div>
              )
            }
          </div>
        </div>
      </CardUI>
    }
  </div>

const CustomerRowUI = ({ loan, customerList, selectedCustomer, onAddCustomerClick }) =>
  <CardUI className='g_m_top_100'
    title={
      <LRTableActionsUI location='top'
        left={
          <div className='g_flex_h'>
            <IconButtonUI icon='icon-plus' onClick={onAddCustomerClick} />
            <span className='g_large'><b>Customers</b></span>
          </div>
        }
        right={<span />}
      />
    }
  >
    {
      customerList && customerList.map((customer, i) =>
        <LRTableRowUI key={i} className='g_flex_top'
          left={
            <div className='g_flex_h g_flex_top'>
              <div>
                <span>
                  {customer.customerName}
                  {
                    customer.addressList && customer.addressList.length &&
                    <span>, {customer.addressList[0].state}</span>
                  }
                </span>
                <div className='g_muted g_flex_v'>
                  <span>
                    {customer.contactFirstName} {customer.contactLastName}
                  </span>
                  <span>{customer.contactPhone}</span>
                  <span>{customer.contactEmail}</span>
                </div>
              </div>
            </div>
          }
        />
      )
    }
  </CardUI>

export default ProjectDetailUI
